import styles from './styles.module.css';
import passos from '../components/imagens/10Passos.png';
import livros from '../components/imagens/20Livros.png';
import acoes from '../components/imagens/40Acoes.png';
import acoes2 from '../components/imagens/40Acoes2.png';
import efeitoDomino from '../components/imagens/EfeitoDomino.png';
import express from '../components/imagens/express.png';
import financas from '../components/imagens/FinançasSegundoABiblia.png';

const courses = [financas, efeitoDomino, express, livros, acoes, passos, acoes2];

export function CarouselTutoriais() {
  return (
    <div className={styles.Container}>
      {courses.map((src, index) => (
        <a
          key={src}
          className={styles.CourseCard}
          href="https://hotmart.com/pt-br/club/mundo-gif"
          target="_blank"
          rel="noopener noreferrer"
          aria-label={`Acessar curso ${index + 1} na Mundo GIF (abre em nova aba)`}
        >
          <div className={styles.CourseCover}>
            <img src={src} alt={`Capa do curso ${index + 1}`} loading="lazy" />
          </div>
          <div className={styles.CourseFooter}>
            <span className={styles.FreeBadge}>Gratuito</span>
            <span className={styles.CourseAction}>Acessar curso <span aria-hidden="true">↗</span></span>
          </div>
        </a>
      ))}
    </div>
  );
}
